import instance from "./instance";
export const findAll = () => {
    return instance.get(`/tags`)
        .then(response => ({ response }))
        .catch(error => ({ error }));
};
